import React, { useContext, useState } from "react";
import { ToastContext } from "./toast.context";
import Toast from "../../components/Elements/Toast/Toast";

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = (status, text, oncloseAction) => {
    setToast({ status, text });
    setTimeout(() => {
      setToast(null);
      if (oncloseAction) {
        oncloseAction();
      }
    }, 5000);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast && <Toast status={toast.status} text={toast.text} />}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
